import * as autoBind from "auto-bind";
import * as React from "react";
import LoadObject from "../../../load_objects/LoadObject";
import { ILogin } from "../../../login/records/Login";
import "./token.css";

interface IProps
{
    token?: string;
}

export default class TokenView extends React.Component<IProps, {}> {

    constructor(props: any)
    {
        super(props);
        autoBind.react(this);

    }

    public render()
    {
        const token = this.props.token;

        return (
            <textarea onClick={this.onTokenClick} className="tokenBox" value={token} readOnly={true} />
        );
    }

    private onTokenClick(evt)
    {
        evt.target.focus();
        evt.target.select();
    }
}
